import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  CollectionComponetTypesActions,
  FlowsActions,
  useContentDispatch,
  useContentSelector,
} from '@wajeez-web/stores/content';

import { ComponentTypeForm } from '../components/ComponentTypeForm';

export const CreateComponentTypePage = () => {
  const { flowId, pageId } = useParams<{ flowId: string; pageId: string }>();

  const navigate = useNavigate();

  const contentDispatch = useContentDispatch();

  const collectionComponent = useContentSelector(
    ({ collectionComponents }) => collectionComponents.details
  );

  useEffect(() => {
    contentDispatch(FlowsActions.getFlowDetailsByIdAsync(Number(flowId)));
  }, []);

  return (
    <div className="p-10">
      <div>
        <ComponentTypeForm
          type="Create"
          onSubmit={async (componentTypeId) => {
            const res = await contentDispatch(
              CollectionComponetTypesActions.addAllowedTypeAsync({
                containerCollectionComponentTypeId: collectionComponent?.typeId,
                allowedComponentTypeId: componentTypeId,
              })
            );

            if (res.meta.requestStatus === 'fulfilled') {
              navigate(
                `/flows/${flowId}/pages/${pageId}/components/new?componentTypeId=${componentTypeId}`
              );
            }
          }}
          onCancel={() => {
            navigate(`/flows/${flowId}/pages/${pageId}/components/new`);
          }}
        />
      </div>
    </div>
  );
};
